export default __webpack_public_path__ + "static/media/dtsp.044fbfa4.jpeg";